import { lazy } from "react";

const PagesRoutes = [
  {
    path: "/",
    exact: true,
    component: lazy(() => import("../../view/splash")),
    layout: "FullLayout",
    pageType: "public",
  },
  {
    path: "/login",
    exact: true,
    component: lazy(() => import("../../view/authentication/login")),
    layout: "FullLayout",
    pageType: "authentication",
  },
  {
    path: "/register",
    exact: true,
    component: lazy(() => import("../../view/authentication/register")),
    layout: "FullLayout",
    pageType: "authentication",
  },
  {
    path: "/home",
    exact: true,
    component: lazy(() => import("../../view/home")),
    layout: "HorizontalLayout",
    pageType: "private",
  },
  {
    path: "/changemobile",
    exact: true,
    component: lazy(() => import("../../view/authentication/changemobile")),
    layout: "HorizontalLayout",
    pageType: "private",
  },
  {
    path: "/pages/blank-page",
    component: lazy(() => import("../../view/pages/blank")),
    layout: "HorizontalLayout",
  },
  {
    path: "/myprofile",
    component: lazy(() => import("../../view/customComponent/myprofile")),
    layout: "HorizontalLayout",
  },
  {
    path: "/RequesttoDelete",
    exact: true,
    component: lazy(() => import("../../view/requestToDelete")),
    layout: "FullLayout",
    pageType: "public",
  },
];

export default PagesRoutes;